import { Pattern, util } from 'fabric';

// Same two tones and tile as the personalizer's transparency background.
const TILE_PX = 8;
export const FILM_LIGHT_TILE = '#bdbdbd';
export const FILM_DARK_TILE = '#9a9a9a';

let filmPattern: Pattern | null | undefined;

// A checkerboard reads as clear film. Null when there is no 2D context (jsdom without node-canvas).
function getFilmPattern(): Pattern | undefined {
  if (filmPattern === undefined) {
    const source = util.createCanvasElement();
    source.width = TILE_PX * 2;
    source.height = TILE_PX * 2;
    const ctx = source.getContext('2d');
    if (ctx) {
      ctx.fillStyle = FILM_LIGHT_TILE;
      ctx.fillRect(0, 0, TILE_PX * 2, TILE_PX * 2);
      ctx.fillStyle = FILM_DARK_TILE;
      ctx.fillRect(0, 0, TILE_PX, TILE_PX);
      ctx.fillRect(TILE_PX, TILE_PX, TILE_PX, TILE_PX);
      filmPattern = new Pattern({ source, repeat: 'repeat' });
    } else {
      filmPattern = null;
    }
  }
  return filmPattern ?? undefined;
}

export default getFilmPattern;
